import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: "/", label: "首页" },
    { to: "/category/all", label: "分类" },
    { to: "/about", label: "关于我们" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
          >
            <span className="text-2xl font-heading font-bold tracking-tight">
              <span className="text-primary-500">4399</span>漫画网
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  location.pathname === link.to
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-primary-500 hover:bg-primary-50"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-48 pl-9 pr-4 py-2 text-sm bg-background-100 border border-background-200 rounded-full focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all duration-200 text-foreground-700 placeholder:text-foreground-300"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-600 hover:bg-background-100 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200">
          <div className="px-4 py-3 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`block px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  location.pathname === link.to
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-2">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-full pl-9 pr-4 py-2.5 text-sm bg-background-100 border border-background-200 rounded-full focus:outline-none focus:border-primary-300 text-foreground-700 placeholder:text-foreground-300"
              />
            </div>
          </div>
        </div>
      )}
    </header>
  );
}